import { observer } from "mobx-react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import Item from "../../interfaces_and_types/orderItemType";
import Order from "../../interfaces_and_types/orderType";
import { useRootStore } from "../../stores";
import "./styles.css";
import { v4 as uuidv4 } from "uuid";
interface IOrderTicket {
  order: Order;
}

const OrderTicket = forwardRef<HTMLDivElement | null, IOrderTicket>(
  (props, ref) => {
    const place = useRootStore().rootStore.placeStore.place;
    const { t, i18n } = useTranslation();

    const getOrderDate = () => {
      if (place === null) return;
      const date = new Date(props.order.orderDate);
      const pad = (num: number) => {
        if (num < 10) return "0" + num;
        return num;
      };

      return (
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        "  " +
        pad(date.getDate()) +
        "/" +
        pad(date.getMonth() + 1) +
        "/" +
        date.getFullYear()
      );
    };

    const courierFee = props.order.isDelivery
      ? (props.order.deliveryPrice ?? 0)
      : 0;

    const renderSubItemsPrice = (item: Item) => {
      let price = 0;
      item.subItemsCategories.forEach((c) =>
        c.subItems.forEach((s) => (price += s.price)),
      );
      return price;
    };

    return (
      <div
        className="ticket-wrapper"
        ref={ref}
        style={{
          fontFamily:
            i18n.language === "ar"
              ? "'Cairo', sans-serif"
              : "'Rubik', sans-serif",
          direction: i18n.language === "en" ? "ltr" : "rtl",
        }}
      >
        <hr className="ticket-solid-line" />
        <hr className="ticket-dashed-line" />
        <hr className="ticket-dashed-line" />
        <header className="ticket-header">
          <div className="ticket-order-number">{props.order.id}</div>
        </header>
        <hr className="ticket-dashed-line" />
        <hr className="ticket-dashed-line" />
        <div className="ticket-first-details">
          <div>{t("Yala ticket")}</div>
          {place && <div>{t(place?.title)}</div>}
          <div>{getOrderDate()}</div>
        </div>
        <hr className="ticket-dashed-line" />
        <hr className="ticket-dashed-line" />
        <div className="ticket-order-items" style={{ gap: "10%" }}>
          {props.order.items.map((item, index) => (
            <div
              key={uuidv4()}
              className="ticket-order-items"
              // style={{
              //   display: 'flex',
              //   flexDirection: 'row',
              //   justifyContent: 'space-between',
              //   width: '100%',
              //   alignSelf: 'flex-start'
              // }}
            >
              <div
                className="ticket-order-items"
                //style={{ display: 'flex', flexDirection: 'column' }}
              >
                <div
                  className="ticket-order-items"
                  //style={{ display: 'flex' }}
                >
                  <p>{t(item.title)}</p>
                  <p
                    style={{
                      marginLeft: "5%",
                      marginRight: "5%",
                      fontWeight: "bold",
                    }}
                  >
                    x{item.quantity}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: "small",
                    alignSelf: "flex-start",
                    width: "100%",
                  }}
                >
                  {item.subItemsCategories.map(
                    (subItemCategory) =>
                      subItemCategory.subItems.length > 0 && (
                        <div
                          key={uuidv4()}
                          style={{
                            display: "flex",
                            alignSelf: "flex-start",
                            width: "100%",
                            flexDirection: "row",
                          }}
                        >
                          <p>
                            {t(subItemCategory.title)}:
                            {subItemCategory.subItems.map((subItem, index) => {
                              return index === 0
                                ? t(subItem.title)
                                : " ," + t(subItem.title);
                            })}
                          </p>
                        </div>
                      ),
                  )}
                </div>
              </div>
              <p className="order-card-item-price">
                {item.price + renderSubItemsPrice(item)}₪
              </p>
            </div>
          ))}
        </div>
        <hr className="ticket-dashed-line" />
        <hr className="ticket-dashed-line" />
        <div className="ticket-order-price">
          <div>
            {t("Total price") +
              "          " +
              (props.order.price + courierFee).toFixed(1)}
          </div>
          <div>
            {t("Total price for restaurant") +
              "          " +
              props.order.price.toFixed(1)}
          </div>
        </div>
        <hr className="ticket-dashed-line" />
        <div className="ticket-delivery-price">
          <div>
            {t("Delivery price") + "          " + courierFee.toFixed(1)}
          </div>
        </div>
        <hr className="ticket-dashed-line" />
        <div className="ticket-order-customer">
          <div>
            {t(props.order.orderer) +
              ":   " +
              t(props.order.ordererMobile ?? t("unknown"))}
          </div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "30px",
              textAlign: "center",
            }}
          >
            {t(props.order.payMethod)}
          </div>
        </div>
        <hr className="ticket-solid-line" />
        <div style={{ textAlign: "center" }}>{t(props.order.address)}</div>
        <hr className="ticket-dashed-line" />
        <hr className="ticket-dashed-line" />
      </div>
    );
  },
);

export default observer(OrderTicket);
